// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import {MeshStandardMaterial,MeshBasicMaterial,AdditiveBlending} from 'three'

/** Restrained, venue-reflecting optical surfaces; no scene colour/refraction pass. */
export function toyOpticalSurface(role:string,opacity:number):MeshStandardMaterial{
 const crystal=role==='core'
 const made=new MeshStandardMaterial({name:'toy.'+role,roughness:crystal?.04:.12,metalness:0,
  transparent:true,opacity,depthWrite:false,envMapIntensity:crystal?1.35:.75})
 made.onBeforeCompile=shader=>{
  if(crystal){shader.defines??={};shader.defines.USE_UV='';shader.fragmentShader=shader.fragmentShader.replace('#include <color_fragment>','#include <color_fragment>\ndiffuseColor.rgb*=.45+.55*clamp(vUv.y,0.0,1.0);')}
  shader.fragmentShader=shader.fragmentShader.replace('#include <opaque_fragment>',`float toyF=.0387+.9613*pow(1.0-clamp(dot(normal,normalize(vViewPosition)),0.0,1.0),5.0);
diffuseColor.a=opacity+${crystal?'.22*clamp(vUv.y,0.0,1.0)+':''}toyF*${crystal?'.32':'.18'};
#include <opaque_fragment>`)
 }
 made.customProgramCacheKey=()=> 'toy-transmissive04-'+role
 return made
}

/** A round tube's optical path fades continuously to zero at its silhouette. */
export function toyLightguide(role:string):MeshBasicMaterial{
 const made=new MeshBasicMaterial({name:'toy.'+role,transparent:true,opacity:0,
  blending:AdditiveBlending,depthWrite:false})
 made.onBeforeCompile=shader=>{
  shader.vertexShader=shader.vertexShader.replace('#include <common>', '#include <common>\nvarying vec3 toyNormal;\nvarying vec3 toyEye;')
   .replace('#include <project_vertex>','#include <project_vertex>\ntoyNormal=normalize(normalMatrix*normal);\ntoyEye=-mvPosition.xyz;')
  shader.fragmentShader=shader.fragmentShader.replace('#include <common>','#include <common>\nvarying vec3 toyNormal;\nvarying vec3 toyEye;')
   .replace('#include <opaque_fragment>','diffuseColor.a*=pow(clamp(abs(dot(normalize(toyNormal),normalize(toyEye))),0.0,1.0),1.5);\n#include <opaque_fragment>')
 }
 made.customProgramCacheKey=()=> 'toy-round-lightguide03'
 return made
}
